// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"UY-z","subtitle":"VY-z","wrapper":"WY-z","leftArrow":"XY-z","rightArrow":"YY-z"};